import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";

import App from "./App";
import { setAppConfig } from "./Bifrost/api";
import reportWebVitals from "./reportWebVitals";
import { getEnv } from "./utils";
import { Base_Url } from "./Constants/ApiRoutes";

async function enableMocking() {
  if (process.env.NODE_ENV !== 'development' || process.env.REACT_APP_MSW_ENABLE !== 'true') {
    return
  }
  const { worker } = await import('./mocks');
 
  return worker.start()
}

if (globalThis.window !== undefined) {
  globalThis.history.scrollRestoration = "manual";
}

const url = new URL(window.location.href);
const params = url.searchParams;
if (params.get("product") === "hiver-for-outlook") {
  params.set("product", "hiver-omni");
  url.search = params.toString();
  window.history.replaceState({}, "", url.toString());
}

const container = document.getElementById("root");

const root = createRoot(container);
const { app_env, tier } = getEnv();
setAppConfig(Base_Url, app_env, tier);
enableMocking().then(() => {
  root.render(<App tab="home" />);
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
